import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Badge, Button, Popconfirm, Space, Table, Tag, Tooltip } from "antd";

export function PostList({
  data = [],
  loading,
  total,
  filter,
  onFilterChange,
  onEdit,
  onDelete,
}) {
  const columns = [
    {
      title: <strong>STT</strong>,
      dataIndex: "key",
      key: "key",
      width: 60,
      align: "center",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: <strong>Hình ảnh</strong>,
      dataIndex: "imageUrl",
      key: "imageUrl",
      width: 150,
      align: "center",
      render: (imageUrl, record) =>
        imageUrl ? (
          <img
            src={imageUrl}
            alt={record.title}
            style={{
              width: 120,
              height: 68,
              objectFit: "cover",
              borderRadius: 6,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          />
        ) : (
          <div
            style={{
              width: 120,
              height: 68,
              backgroundColor: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#999",
              borderRadius: 6,
              fontSize: 12,
            }}
          >
            Không có hình
          </div>
        ),
    },
    {
      title: <strong>Tiêu đề</strong>,
      dataIndex: "title",
      key: "title",
      width: 250,
      render: (title) => (
        <Tooltip title={title}>
          <strong>{title}</strong>
        </Tooltip>
      ),
    },

    {
      title: <strong>Loại</strong>,
      dataIndex: "type",
      key: "type",
      align: "center",
      width: 120,
      render: (type) => <Tag color="blue">{type?.name || "N/A"}</Tag>,
    },
    {
      title: <strong>Tags</strong>,
      dataIndex: "tags",
      key: "tags",
      width: 200,
      render: (tags) =>
        tags?.length ? (
          <Space wrap>
            {tags.map((tag) => (
              <Tag key={tag._id || tag} color="green" variant="outlined">
                {tag.name || tag}
              </Tag>
            ))}
          </Space>
        ) : null,
    },
    {
      title: <strong>Tác giả</strong>,
      dataIndex: "internalAuthor",
      key: "internalAuthor",
      width: 250,
    },
    {
      title: <strong>Trạng thái</strong>,
      dataIndex: "isActive",
      key: "isActive",
      align: "center",
      width: 120,
      render: (isActive) => (
        <Badge
          status={isActive ? "success" : "error"}
          text={isActive ? "Hoạt động" : "Ngừng hoạt động"}
        />
      ),
    },
    {
      title: <strong>Hành động</strong>,
      key: "action",
      width: 120,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Sửa">
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
              style={{ color: "#1890ff" }}
            />
          </Tooltip>
          <Popconfirm
            title="Bạn có chắc muốn xóa?"
            onConfirm={() => onDelete(record._id)}
            okText="Có"
            cancelText="Không"
          >
            <Tooltip title="Xóa">
              <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      scroll={{ x: 1200 }}
      columns={columns}
      dataSource={
        data.length
          ? data.map((item, idx) => ({
              ...item,
              ...(filter && {
                key: (filter.page - 1) * filter.limit + idx + 1,
              }),
            }))
          : []
      }
      loading={loading}
      rowKey="_id"
      pagination={{
        current: filter.page,
        pageSize: filter.limit,
        total,
        showSizeChanger: true,
        onChange: (page, pageSize) =>
          onFilterChange({ ...filter, page, limit: pageSize }),
      }}
      size="middle"
      bordered
      rowClassName={() => "hover-row"}
    />
  );
}
